export default "__VITE_ASSET__QI4k3FSA__"